import * as React from "react";
import { graphql } from 'gatsby';
import NotFound from 'pages/404';
import useLiveData from 'hooks/useLiveData';
import Contact from 'components/Staff/ContactPageForm';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import zparse from 'components/zparse';
import { DateTime } from "luxon";
import { dateFormat } from "../utils/theme";
import InsightsSlider from 'components/Insights/InsightsSlider'
import Link from 'components/Link';

/**
 *	@TODO:
 * 	1. Form above footer
 */

const BlogPostGet = (props) => {
	const { edges } = props.data.allBlogPost;
	const nodes = edges.map(({node}) => node);
	const {statusText: providerStatusText, status: providerStatus, response: providerResponse, visibilityChange} = useLiveData({
		type: 'BlogPost',
		apiParams: {
			uri: props.location.pathname,
			_join: 'Topic',
		},
		staticData: props.data,
	});
	let page = nodes[0];
	if (((providerResponse && providerResponse.data.length > 0) || !!page !== false) && providerStatusText === 'LOADED') {
		page = providerResponse.data[0];
	}
	if (providerResponse && visibilityChange)page = providerResponse.data[0];
	if (!!page === false && providerStatus >= 2)return <NotFound/>; // We only go to a page not found after the API loads or has an error and there's no page found.
	// if (props.providerStatus < 2){// This prevents any flash of content until the API is loaded -- but if the API takes a while to respond the effect would be the page loads slower. You could also use state to reveal content with a transition
	// 	return null;
	// }

	let dateString;
	if (!!page?.showDate !== false) {
		const parsed = DateTime.fromISO(page?.showDate);
		if (parsed.isValid)dateString = parsed.toLocaleString(dateFormat);
		else dateString = page?.showDate;
	}

	return (
		<div className={`loadWrap ${providerStatus >= 2 ? 'loaded' : ''}`}>
			{ providerStatus >= 2 && 
			<>
				<Box component="section" className="blog__post__masthead" sx={{paddingTop: { xs: "150px", md: "329px" }, display: 'flex', alignItems: 'flex-end',}}>
					<Container className="blog__post__masthead__content">
						<Grid container>
							<Grid size={{ xs: 12, md: 10, lg: 9 }} offset={{ xs: 0, md: 1, lg: 1.5 }}>
								<Grid container>
									<Grid>
										<Typography sx={{marginBottom: '18px'}} component="h1" variant="h1">{page?.title}</Typography>
									</Grid>
								</Grid>
								<Grid container direction="row" spacing={3}>
									{dateString && <Grid size="auto">
										<Typography component='p' variant={'p__blog__post__masthead__date'}>{dateString}</Typography>
									</Grid>}
									<Grid size="auto">
										{page?.Topic && Array.isArray(page?.Topic) && 
											<Box component="div" className="blog__post__masthead__topics__container">
											{page?.Topic.map((item,index) => (
												<Paper key={`blog__post__masthead__topic_${index}`} className="topic__chip" variant="label"><Box component="span" className="topic__chip__label">{item?.object?.name}</Box></Paper>
											))}
											</Box>
										}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Container>
				</Box>
				<Container className="content blog__post__content">
					<Grid container >
						<Grid size={{ xs: 12, md: 10, lg: 9 }} offset={{ xs: 0, md: 1, lg: 1.5 }}>
							<Box>{zparse(page?.body)}</Box>
						</Grid>
						<Grid size={12} sx={{textAlign: 'center'}}>
							<Typography sx={{marginTop: {xs: '32px', md: '0'}, marginBottom: '24px'}} variant={'h3'}>Ready To Dive In?</Typography>
							<Button component={Link} href="#contact" variant={'contained'}>Let's Go</Button>
						</Grid>
					</Grid>
				</Container>
				<InsightsSlider title={'Related News Articles'} link={'/insights/'} linkText="View All Insights" />
				<Contact id="contact" smallPadding={true} />
			</>
			}
		</div>
	)
}

export default BlogPostGet;

export { Head } from 'components/Head';

export const query = graphql`
query ($permalink: String) {
	allBlogPost(
	  filter: {permalink: {eq: $permalink}, deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}
	) {
	  edges {
		node {
		  id
		  title
		  intro
		  body
		  photo
		  showDate
	      permalink
		  Topic {
		  	id
			object {
				name
			}
		  }
		}
	  }
	}
  }
`